import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function ArticleCards() {
  return (
    <section id="articles" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 mb-3">
            Latest Guides
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900 mb-4">
            Expert Articles & Resources
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Dive deeper into the world of CSSBuy spreadsheets with our in-depth guides, comparison articles, and expert tips designed to help you shop smarter and find better deals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {allArticles.map((article) => (
            <Link
              key={article.id}
              to={article.slug}
              className="group bg-white border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300/50 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-6 flex flex-col">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                    {article.tag}
                  </span>
                  <span className="text-foreground-400 text-xs">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors duration-300 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4 line-clamp-2">
                  {article.description}
                </p>
                <span className="inline-flex items-center text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors duration-200 whitespace-nowrap mt-auto">
                  Read Article
                  <i className="ri-arrow-right-line ml-1.5 group-hover:translate-x-1 transition-transform duration-200"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-foreground-500 text-sm">
            More guides coming soon — bookmark this page and check back weekly for new content.
          </p>
        </div>
      </div>
    </section>
  );
}